import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useAdminSession } from "../../hooks/useAdminSession";
import { securityMonitoringApi } from "../../services/securityMonitoringApi";
import { Button } from "../common/Button";
import { Badge } from "../common/Badge";
import styles from "./TopBar.module.css";

export function TopBar({ onMenuToggle }) {
  const { logout, account } = useAuth();
  const { label: sessionLabel, showWarning, extendSession } = useAdminSession();
  const [menuOpen, setMenuOpen] = useState(false);
  const [ipAllowlistEnforced, setIpAllowlistEnforced] = useState(null);

  useEffect(() => {
    securityMonitoringApi
      .ipAllowlistStatus()
      .then((r) => setIpAllowlistEnforced(!!r.enforced))
      .catch(() => setIpAllowlistEnforced(false));
  }, []);

  return (
    <header className={styles.bar}>
      <button className={[styles.iconButton, styles.menuButton].join(" ")} onClick={onMenuToggle} aria-label="Toggle navigation menu">
        ☰
      </button>

      <a href="/" className={styles.brand}>🐝 Bee Keeper Admin</a>

      {ipAllowlistEnforced === true && <Badge tone="info">IP Allowlist Active</Badge>}
      {ipAllowlistEnforced === false && <Badge tone="neutral">IP Allowlist: Not Configured</Badge>}

      <div className={styles.spacer} />

      <div className={[styles.sessionInfo, showWarning ? styles.warning : ""].join(" ")} title="Time remaining in this admin session (15-min cap)">
        <span aria-hidden="true">⏱</span>
        <span>{sessionLabel}</span>
        {showWarning && (
          <Button size="sm" variant="ghost" onClick={extendSession}>
            Stay signed in
          </Button>
        )}
      </div>

      <div className={styles.userMenu}>
        <button className={styles.iconButton} onClick={() => setMenuOpen((v) => !v)} aria-haspopup="true" aria-expanded={menuOpen}>
          👤
        </button>
        {menuOpen && (
          <div className={styles.dropdown} role="menu">
            <div style={{ padding: "8px 16px", fontSize: "0.85rem", color: "var(--color-text-muted)" }}>
              {account?.username || "Signed in"}
            </div>
            <Button variant="ghost" size="sm" onClick={logout} className={styles.dropdownItem}>
              Sign out
            </Button>
          </div>
        )}
      </div>
    </header>
  );
}
